 
import { Mixin } from 'mixwith';
import { ElementNodeBuilder } from 'Editor/services/Model';
import { ELEMENTS } from 'Editor/services/consts';

export default Mixin(
  (superclass) =>
    class extends superclass {
      parseSectionBreakNode(representation) {
        const builder = new ElementNodeBuilder();
        builder.addElementType(ELEMENTS.SectionBreakElement.ELEMENT_TYPE);
        if (representation.attributes.parent_id) {
          builder.addParentId(representation.attributes.parent_id.nodeValue);
        }
        if (representation.attributes.id) {
          builder.addId(representation.attributes.id.nodeValue);
        }
        if (representation.attributes.n_sct) {
          builder.addProperty('n_sct', representation.attributes.n_sct.nodeValue);
        }
        return builder.getNode();
      }
    },
);
